import { mapMutations } from 'vuex'
import { isObject } from 'lodash'
import { isArrayWithLength } from '~/ZenOne-StoryBook/helpers/types'
import updateProductDistributor from '~/mixins/updateProductDistributor'
import { isHavingProps } from '~/ZenOne-StoryBook/helpers/object'

export default {
  mixins: [updateProductDistributor],
  methods: {
    ...mapMutations('catalog', {
      setTopItem: 'SET_TOP_ITEM',
    }),
    updateProductDistributorInList(productDistributorId = null, data = {}) {
      const {
        products: { list = [] },
      } = this
      if (!isArrayWithLength(list)) return false
      const index = list.findIndex(
        (productDistributor) =>
          parseInt(productDistributor.productDistributorId) ===
          productDistributorId
      )
      if (index !== -1) {
        const productDistributor = {
          ...{ ...this.products.list[index] },
          ...data,
        }
        this.$set(this.products.list, index, productDistributor)
      }
    },
    // todo need to use this method everywhere in catalog updates
    updateCatalogProductDistributor(productDistributorId = null, data = {}) {
      productDistributorId = parseInt(productDistributorId)
      if (this.isFiltersActive || this.isSearchActive) {
        this.updateProductDistributorInList(productDistributorId, data)
      } else {
        this.updateProductDistributorInTops(productDistributorId, data)
      }
    },
    findProductByAttr(value = null, attribute = '') {
      return (
        this.searchProductInCatalogByAttr(value, attribute) ||
        this.searchProductInTopsByAttr(value, attribute)
      )
    },
    searchProductInCatalogByAttr(value = null, attribute = '') {
      const products = this.products?.list ?? []
      if (!isArrayWithLength(products)) return null
      const index = products.findIndex((pd) => pd?.[attribute] === value)
      if (index === -1) return null
      return products[index]
    },
    searchProductInTopsByAttr(value = null, attribute = '') {
      const tops = this.topsList
      const topsList =
        tops && isObject(tops) && isHavingProps(tops)
          ? { ...this.topsList }
          : {}
      if (!isHavingProps(topsList)) return null
      const {
        topsList: {
          ordered: { productList: ordered = [] },
          recentlyPurchased: { productList: recentlyPurchased = [] },
          mostPurchased: { productList: mostPurchased = [] },
        },
      } = this
      if (
        !isArrayWithLength(ordered) &&
        !isArrayWithLength(recentlyPurchased) &&
        !isArrayWithLength(mostPurchased)
      ) {
        return null
      }
      const list = {
        ordered,
        recentlyPurchased,
        mostPurchased,
      }
      return this.findTopItemByAttr(value, attribute, list)
    },
    findTopItemByAttr(value = null, attribute = '', list = {}) {
      const { ordered = [], recentlyPurchased = [], mostPurchased = [] } = list
      if (!attribute) {
        return null
      }
      if (isHavingProps(ordered)) {
        const index = ordered.findIndex((pd) => pd?.[attribute] === value)
        if (index !== -1) {
          return ordered[index]
        }
      }
      if (isHavingProps(recentlyPurchased)) {
        const index = recentlyPurchased.findIndex(
          (pd) => pd?.[attribute] === value
        )
        if (index !== -1) {
          return recentlyPurchased[index]
        }
      }
      if (isHavingProps(mostPurchased)) {
        const index = mostPurchased.findIndex((pd) => pd?.[attribute] === value)
        if (index !== -1) {
          return mostPurchased[index]
        }
      }

      return null
    },
  },
}
